export default __webpack_public_path__ + "static/media/qrcode_1.bb2bee6c.png";